// extracted by mini-css-extract-plugin
export default {"loading-wrapper":"KVnfY5U2S8DVB5mwBIYG8w=="};